<template>
  <div class="context--menu" :class="{block: toggleShow}" :style="style">
    <ul>
      <li v-for="(menu, i) in menuList" @click.stop="!menu.disabled && $emit('menuClick', menu)" :key="i" :class="{'is-divided': menu.divided,'is-disabled': menu.disabled}">
        <i :class="menu.icon" v-if="menu.icon"></i>
        <span>{{menu.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contextMenu',
  props: {
    position: {
      type: Object,
      default: () => {
        return {}
      }
    },
    toggleShow: {
      type: Boolean,
      default: false
    },
    menuList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    style () {
      let {top, left, bottom, right} = this.position
      let style = {}
      top && (style.top = top + 'px')
      left && (style.left = left + 'px')
      bottom && (style.bottom = bottom + 'px')
      right && (style.right = right + 'px')
      return style
    }
  }
}
</script>

<style scoped lang="less">
  .context--menu {
    width: 100px;
    padding: 8px 0;
    position: fixed;
    z-index: 9999;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    display: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    &.block {
      display: block;
    }
    ul {
      margin: 0;
      li {
        width: 100%;
        display: flex;
        height: 32px;
        line-height: 32px;
        padding: 0 16px;
        cursor: pointer;
        box-sizing: border-box;
        /*&:last-child {*/
          /*border-top: 1px solid rgba(33,37,48,0.1);*/
        /*}*/
        &.is-divided {
          position: relative;
          margin-top: 6px;
          border-top: 1px solid #ebeef5;
        }
        &.is-disabled{
          color: #ccc;
          cursor: not-allowed;
        }
        &:hover {
          background: #fafafa;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }
</style>
